const truthy = (value) => String(value || "").trim().toLowerCase() === "true";

export const APPLE_SUBSCRIPTIONS_URL = "https://apps.apple.com/account/subscriptions";
export const GOOGLE_PLAY_SUBSCRIPTIONS_URL = "https://play.google.com/store/account/subscriptions";
export const MICROSOFT_SUBSCRIPTIONS_URL = "https://account.microsoft.com/services";

function safeAccountPortalUrl(value) {
  if (!value) return "";
  try {
    const url = new URL(String(value).trim());
    if (
      url.protocol !== "https:"
      || url.hostname !== "account.lightningflow.ai"
      || url.username
      || url.password
      || url.hash
    ) {
      return "";
    }
    return url.toString();
  } catch {
    return "";
  }
}

export function buildHaloAccountConfig(env = process.env) {
  const accountPortalUrl = safeAccountPortalUrl(
    env.REACT_APP_HALO_ACCOUNT_PORTAL_URL,
  );
  const portalEnabled =
    truthy(env.REACT_APP_HALO_ACCOUNT_PORTAL_ENABLED) && Boolean(accountPortalUrl);

  return {
    portalEnabled,
    accountPortalUrl: portalEnabled ? accountPortalUrl : "",
    supportEmail: "contact@lightningflow.ai",
  };
}

export const haloAccount = buildHaloAccountConfig();
